/**
 * Définitions des tutoriels pour chaque espace
 * Agrégation des sous-modules (dashboards + fonctionnalités).
 */
import { TUTORIALS_DASHBOARDS } from './tutorialsDashboards';
import { TUTORIALS_FEATURES } from './tutorialsFeatures';

export const TUTORIALS = {
  ...TUTORIALS_DASHBOARDS,
  ...TUTORIALS_FEATURES
};

/**
 * Obtenir un tutoriel par ID
 */
export const getTutorial = (tutorialId) => {
  return TUTORIALS[tutorialId] || null;
};

/**
 * Obtenir tous les tutoriels d'un type d'espace
 */
export const getTutorialsBySpace = (space) => {
  const spaceTutorials = {
    member: [
      'member_dashboard', 
      'simulateur',
      'subscription_management', 
      'wallet_management', 
      'bibliotheque', 
      'videos_management',
      'messaging', 
      'declare_dommage'
    ],
    admin: [
      'admin_dashboard',
      'nomenclatures_management',
      'videos_management',
      'messaging',
      'admin_billing'
    ],
    superadmin: [
      'superadmin_dashboard',
      'nomenclatures_management',
      'videos_management',
      'admin_billing'
    ],
    cooper: [
      'cooper_dashboard',
      'simulateur',
      'videos_management',
      'messaging',
      'bibliotheque'
    ],
    expert: [
      'expert_dashboard',
      'simulateur',
      'videos_management',
      'messaging'
    ]
  };

  return (spaceTutorials[space] || []).map(id => TUTORIALS[id]).filter(Boolean);
};

/**
 * Obtenir tous les tutoriels disponibles
 */
export const getAllTutorials = () => {
  return Object.values(TUTORIALS);
};

/**
 * Obtenir les tutoriels par catégorie
 */
export const getTutorialsByCategory = () => {
  return {
    'Espaces Utilisateurs': [
      'member_dashboard',
      'admin_dashboard',
      'superadmin_dashboard',
      'cooper_dashboard',
      'expert_dashboard'
    ],
    'Fonctionnalités': [
      'simulateur',
      'videos_management',
      'messaging',
      'declare_dommage',
      'nomenclatures_management'
    ],
    'Gestion': [
      'subscription_management',
      'wallet_management',
      'bibliotheque',
      'admin_billing'
    ]
  };
};
